const MerchandiseSearch = () => {
  return (
    <div className='merchandise__header'>
      <h2 className='merchandise__header-title'>Merchandise</h2>
    </div>
  )
}

export default MerchandiseSearch
